import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as Dialog from '@radix-ui/react-dialog';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import AccessibleModal, {
    AccessibleModalCloseButton,
} from '../AccessibleModal';

import { gettext } from '../../utils/text';
import GallerySlider from './GallerySlider';
import sort from './utils';

const BlogGalleryLink = ({ data }) => {
    const [isOpen, setIsOpen] = useState(false);
    const translatedText = gettext('Open Gallery');
    const linkText = `${translatedText} (${data.images.length})`;

    const images = data.images.sort(sort);

    return (
        <Dialog.Root open={isOpen} onOpenChange={setIsOpen}>
            <Dialog.Trigger asChild>
                <button
                    type="button"
                    onClick={() => setIsOpen(true)}
                    className="btn btn-link text-decoration-none p-0 d-inline-flex align-items-center gap-2"
                    aria-label={linkText}
                >
                    <img
                        alt=""
                        src={`${DJ_CONST.STATIC_URL}images/elements/icon-image.png`}
                        className="masthead__gallery-link__icon pe-none"
                    />
                    {linkText}
                </button>
            </Dialog.Trigger>
            <AccessibleModal
                contentClassName="gallery-modal"
                contentStyle={{
                    width: '100vw',
                    maxWidth: '100vw',
                    height: '100vh',
                }}
                initialFocusSelector=".splide__arrow--next"
            >
                <Dialog.Title asChild>
                    <VisuallyHidden>{translatedText}</VisuallyHidden>
                </Dialog.Title>
                <Dialog.Description asChild>
                    <VisuallyHidden>
                        {gettext(
                            'Image gallery. Use the next and previous buttons to browse images.',
                        )}
                    </VisuallyHidden>
                </Dialog.Description>
                <AccessibleModalCloseButton
                    className="btn-close btn-close-white position-absolute top-0 end-0 m-3 m-md-4"
                    aria-label={gettext('Close')}
                />
                <GallerySlider images={images} initialSlide={0} />
            </AccessibleModal>
        </Dialog.Root>
    );
};

BlogGalleryLink.propTypes = {
    data: PropTypes.shape({
        images: PropTypes.arrayOf(
            PropTypes.shape({
                file: PropTypes.shape({
                    pk: PropTypes.number,
                    file: PropTypes.string,
                    thumbnail: PropTypes.string,
                }),
            }),
        ).isRequired,
    }).isRequired,
};

export default BlogGalleryLink;
